import React from 'react';
import usePersistedState from 'shared/hooks/usePersistedState';
import styled from 'styled-components/macro';
import { PersistedStateKeys } from 'shared/enums';

interface IDevModeDisplayStringProps {
  src: string | undefined;
}

const DevModeDisplayString = ({ src }: IDevModeDisplayStringProps): JSX.Element => {
  const [isDeveloperModeEnabled] = usePersistedState(PersistedStateKeys.IsDeveloperModeEnabled, false);

  return isDeveloperModeEnabled ? <StringDisplay>{src}</StringDisplay> : <></>;
};

export default DevModeDisplayString;

const StringDisplay = styled.div`
  font-family: monospace;
`;
